import { render, staticRenderFns } from "./changeBaselineModal.vue?vue&type=template&id=649f63be"
import script from "./changeBaselineModal.js?vue&type=script&lang=js&external"
export * from "./changeBaselineModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports